const prefix = 'iam-authority';

const SET_ALL_AUTHORITIES = `${prefix}/SET_ALL_AUTHORITIES`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_ALL_AUTHORITIES, RESET, SET_LOADING };
